import Php2ShellVulnerabilities from "../pages/blog/Php2ShellVulnerabilities";
import CloudSyncDMacosBackdoor from "../pages/blog/CloudSyncDMacosBackdoor";
import Q3RansomwareTrends from "../pages/blog/Q3RansomwareTrends";
import CveExchangeServerPrivEsc from "../pages/blog/CveExchangeServerPrivEsc";
import ChainsTheyCantSeize from "../pages/blog/ChainsTheyCantSeize";
import VexyRansomwareThreatIntel from "../pages/blog/VexyRansomwareThreatIntel";
import LicindiaMeduzaLockerClaim from "../pages/blog/LicindiaMeduzaLockerClaim";
import AgenticSocGuide from "../pages/blog/AgenticSocGuide";
import AccentureBreachClaim from "../pages/blog/AccentureBreachClaim";
import PappyJoeBreachClaim from "../pages/blog/PappyJoeBreachClaim";
import RapidFortBreachClaim from "../pages/blog/RapidFortBreachClaim";
import BankOfBarodaBreachClaim from "../pages/blog/BankOfBarodaBreachClaim";
import php2shellCoverImage from "../assets/blog/php2shell-php-vulnerabilities/cover.svg";
import cloudSyncDCoverImage from "../assets/blog/cloudsyncd-macos-backdoor/cover.svg";
import q3TrendsCoverImage from "../assets/blog/q3-2026-ransomware-trends/cover.svg";
import cveCoverImage from "../assets/blog/cve-2026-96940-exchange/cover.svg";
import chainsCoverImage from "../assets/blog/chains-they-cant-seize/cover.svg";
import vexyCoverImage from "../assets/blog/vexy-ransomware/cover.svg";
import licindiaCoverImage from "../assets/blog/licindia-meduzalocker-breach/fig1-root-directory.png";
import agenticSocCoverImage from "../assets/blog/agentic-soc-guide/spend-imbalance-chart.png";
import accentureCoverImage from "../assets/blog/accenture-breach/forum-post-overview.png";
import pappyJoeCoverImage from "../assets/blog/pappyjoe-breach/forum-post-overview.png";
import rapidFortCoverImage from "../assets/blog/rapidfort-breach/sale-post.jpg";
import bankOfBarodaCoverImage from "../assets/blog/bank-of-baroda-breach/triplex-post.png";
import BLOG_POSTS_META from "./blogPostsMeta";

const COMPONENTS = {
  "php2shell-php-runtime-rce-cve-2026-109618-109619": Php2ShellVulnerabilities,
  "cloudsyncd-macos-backdoor-fake-zoom-installer": CloudSyncDMacosBackdoor,
  "q3-2026-ransomware-trends-report": Q3RansomwareTrends,
  "cve-2026-96940-exchange-server-elevation-of-privilege": CveExchangeServerPrivEsc,
  "chains-they-cant-seize-ransomware-blockchain-infrastructure": ChainsTheyCantSeize,
  "vexy-ransomware-raas-threat-intelligence": VexyRansomwareThreatIntel,
  "licindia-meduzalocker-data-exposure-claim": LicindiaMeduzaLockerClaim,
  "agentic-soc-security-leaders-guide-2026": AgenticSocGuide,
  "bank-of-baroda-data-breach-triplex-claim": BankOfBarodaBreachClaim,
  "rapidfort-569gb-data-sale-claim": RapidFortBreachClaim,
  "pappyjoe-data-breach-claim-kazu-extortion": PappyJoeBreachClaim,
  "accenture-breach-claim-underground-forum": AccentureBreachClaim,
};

const IMAGES = {
  "php2shell-php-runtime-rce-cve-2026-109618-109619": php2shellCoverImage,
  "cloudsyncd-macos-backdoor-fake-zoom-installer": cloudSyncDCoverImage,
  "q3-2026-ransomware-trends-report": q3TrendsCoverImage,
  "cve-2026-96940-exchange-server-elevation-of-privilege": cveCoverImage,
  "chains-they-cant-seize-ransomware-blockchain-infrastructure": chainsCoverImage,
  "vexy-ransomware-raas-threat-intelligence": vexyCoverImage,
  "licindia-meduzalocker-data-exposure-claim": licindiaCoverImage,
  "agentic-soc-security-leaders-guide-2026": agenticSocCoverImage,
  "bank-of-baroda-data-breach-triplex-claim": bankOfBarodaCoverImage,
  "rapidfort-569gb-data-sale-claim": rapidFortCoverImage,
  "pappyjoe-data-breach-claim-kazu-extortion": pappyJoeCoverImage,
  "accenture-breach-claim-underground-forum": accentureCoverImage,
};

export const BLOG_POSTS = BLOG_POSTS_META.map((meta) => ({
  ...meta,
  image: IMAGES[meta.slug],
  component: COMPONENTS[meta.slug],
}));

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((post) => post.slug === slug);
}
